import React, { useCallback } from "react";

import StepLingerieQuestion from "../../StepLingerieQuestion";
import { MODAL_STEPS } from "../../../../../constants/modal";
import {
  LINGERIE_QUESTIONS,
  LingerieAnswers,
} from "../../../../../constants/lingerieFlow";
import { logger } from "../../../../../utils";

interface LingerieStepsProps {
  step: { number: number } | null;
  setStep: (step: { number: number }) => void;
  subtitlesStyles: React.CSSProperties;
  submitLingerieAnswers: () => void | Promise<void>;
  lingerieAnswers: LingerieAnswers;
  setLingerieAnswer: (answer: Partial<LingerieAnswers>) => void;
}

const LingerieSteps: React.FC<LingerieStepsProps> = ({
  step,
  setStep,
  subtitlesStyles,
  submitLingerieAnswers,
  lingerieAnswers,
  setLingerieAnswer,
}) => {
  const safeSubmitLingerieAnswers = useCallback(async () => {
    try {
      await submitLingerieAnswers();
    } catch (err) {
      logger.error("submitLingerieAnswers failed", err);
    }
  }, [submitLingerieAnswers]);

  return (
    <>
      {LINGERIE_QUESTIONS.map((config, index) => {
        const stepNumber = MODAL_STEPS[config.stepKey].number;
        if (step?.number !== stepNumber) return null;

        const isLast = index === LINGERIE_QUESTIONS.length - 1;
        const nextConfig = LINGERIE_QUESTIONS[index + 1];

        const nextStep = isLast
          ? () => safeSubmitLingerieAnswers()
          : () => setStep(MODAL_STEPS[nextConfig.stepKey]);

        return (
          <StepLingerieQuestion
            key={config.apiField}
            config={config}
            value={lingerieAnswers[config.apiField]}
            onChange={(val) => setLingerieAnswer({ [config.apiField]: val })}
            nextStep={nextStep}
            subtitlesStyles={subtitlesStyles}
          />
        );
      })}
    </>
  );
};

export default React.memo(LingerieSteps);
